import { createI18n } from "vue-i18n";
import messages from "../../locale/messages.json";

const i18n = createI18n({
  legacy: false,
  locale: "en",
  globalInjection: true,
  messages,
});

export default i18n;
